<script>
  import TextArea from './TextArea.svelte';
  import { createEventDispatcher } from 'svelte';

  export let
    value = '',
    maxLength = 0,
    placeholder = '',
    readonly,
    maxHeight,
    error;

  const dispatchEvent = createEventDispatcher();

  function dispatch(e){
    if(!readonly) {
      value = maxLength ? e.detail.substring(0, maxLength) : e.detail;
      dispatchEvent(e.type, value);
    }
  }

</script>

<div class="Component" >
  <div class="Label" class:Error="{error}"><slot /></div>

  {#if maxLength && !readonly}
    <div class="Counter" class:Error="{error}">{`${value ? value.length : 0}/${maxLength}`}</div>
  {/if}

  <div class="TextArea" class:Error="{error}" style="{maxHeight? `max-height: ${maxHeight}; overflow:auto;`: ''}">
    <TextArea bind:value
              {placeholder}
              {readonly}
              on:input="{e => dispatch(e)}"
              on:change="{e => dispatch(e)}"
    />
  </div>
</div>


<style lang="stylus">

  .Component {
    position: relative;
    padding-top: 15px;
  }

  Label = @block {
    position absolute;
    top: 7px;
    z-index: 1;
    background: white;
    font-size : 12px;
    line-height : 12px;
    color: #B0BEC5;
    padding: 0 5px;

    &.Error {
      color: #F15A24;
    }
  }

  .Label {
    {Label}
    left: 10px;
  }

  .Counter {
    {Label}
    right: 10px;
  }

  .TextArea {
    border: 1px solid #CFD8DC;
    border-radius: 6px;

    :global(.TextAreaInputContainer) {
      font-size: 14px;
      line-height: 20px;
      min-height: 20px;
      font-weight: normal;
      font-family: "Noto Sans", sans-serif;
      color: #546E7A;
      padding: 10px 10px 5px;
    }


    &.Error {
      :global(.TextAreaInputContainer) {
        border-color: #F15A24;
      }
    }
  }
</style>

